// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingDiv {
    display: block!important;
    text-align: center!important;
    line-height: 1px;
    padding: .5em;
}

.cog {
    margin: 0;
    padding: 0;
    margin-bottom: -8px;
    margin-right: -7.25px;
    color: #555;
}

.cog-top {
    margin-left: 43px;
    margin-bottom: -12px;
}

.cog-middle {
    margin-bottom: 0;
}

.spin-forward {
    -webkit-animation: spin-forward 2s infinite linear;
    animation: spin-forward 2s infinite linear;
}

.spin-reverse {
    -webkit-animation: spin-reverse 2s infinite linear;
    animation: spin-reverse 2s infinite linear;
}

@-webkit-keyframes spin-forward {
    100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    0% {
        -webkit-transform: rotate(-359deg);
        transform: rotate(-359deg);
    }
}

@keyframes spin-forward {
    100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    0% {
        -webkit-transform: rotate(-359deg);
        transform: rotate(-359deg);
    }
}

@-webkit-keyframes spin-reverse {
    100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    0% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

@keyframes spin-reverse {
    100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    0% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

.help {
      cursor: help;
}
.exculsion-text {
    color: red;
    text-decoration: underline;
    font-weight: 700;
}

.material-override {
    float: left
}
.error-upload {
    color: #f5ecec;
    background-color: #b91717;
    border-color: #b91717;
}

.packingfooter-bold {
    font-weight: 700
}

.packing-footer-one-bold {
    font-weight: 700;
    text-decoration: underline;
}

@media print {
    body {
        display: table;
        table-layout: fixed;
    }
}`, "",{"version":3,"sources":["webpack://./src/Shared/ComponentLoading.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kDAAkD;IAClD,0CAA0C;AAC9C;;AAEA;IACI,kDAAkD;IAClD,0CAA0C;AAC9C;;AAEA;IACI;QACI,+BAA+B;QAC/B,uBAAuB;IAC3B;;IAEA;QACI,kCAAkC;QAClC,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B,uBAAuB;IAC3B;;IAEA;QACI,kCAAkC;QAClC,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B,uBAAuB;IAC3B;;IAEA;QACI,iCAAiC;QACjC,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B,uBAAuB;IAC3B;;IAEA;QACI,iCAAiC;QACjC,yBAAyB;IAC7B;AACJ;;AAEA;MACM,YAAY;AAClB;AACA;IACI,UAAU;IACV,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI;AACJ;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI;QACI,cAAc;QACd,mBAAmB;IACvB;AACJ","sourcesContent":[".loadingDiv {\r\n    display: block!important;\r\n    text-align: center!important;\r\n    line-height: 1px;\r\n    padding: .5em;\r\n}\r\n\r\n.cog {\r\n    margin: 0;\r\n    padding: 0;\r\n    margin-bottom: -8px;\r\n    margin-right: -7.25px;\r\n    color: #555;\r\n}\r\n\r\n.cog-top {\r\n    margin-left: 43px;\r\n    margin-bottom: -12px;\r\n}\r\n\r\n.cog-middle {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.spin-forward {\r\n    -webkit-animation: spin-forward 2s infinite linear;\r\n    animation: spin-forward 2s infinite linear;\r\n}\r\n\r\n.spin-reverse {\r\n    -webkit-animation: spin-reverse 2s infinite linear;\r\n    animation: spin-reverse 2s infinite linear;\r\n}\r\n\r\n@-webkit-keyframes spin-forward {\r\n    100% {\r\n        -webkit-transform: rotate(0deg);\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    0% {\r\n        -webkit-transform: rotate(-359deg);\r\n        transform: rotate(-359deg);\r\n    }\r\n}\r\n\r\n@keyframes spin-forward {\r\n    100% {\r\n        -webkit-transform: rotate(0deg);\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    0% {\r\n        -webkit-transform: rotate(-359deg);\r\n        transform: rotate(-359deg);\r\n    }\r\n}\r\n\r\n@-webkit-keyframes spin-reverse {\r\n    100% {\r\n        -webkit-transform: rotate(0deg);\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    0% {\r\n        -webkit-transform: rotate(359deg);\r\n        transform: rotate(359deg);\r\n    }\r\n}\r\n\r\n@keyframes spin-reverse {\r\n    100% {\r\n        -webkit-transform: rotate(0deg);\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    0% {\r\n        -webkit-transform: rotate(359deg);\r\n        transform: rotate(359deg);\r\n    }\r\n}\r\n\r\n.help {\r\n      cursor: help;\r\n}\r\n.exculsion-text {\r\n    color: red;\r\n    text-decoration: underline;\r\n    font-weight: 700;\r\n}\r\n\r\n.material-override {\r\n    float: left\r\n}\r\n.error-upload {\r\n    color: #f5ecec;\r\n    background-color: #b91717;\r\n    border-color: #b91717;\r\n}\r\n\r\n.packingfooter-bold {\r\n    font-weight: 700\r\n}\r\n\r\n.packing-footer-one-bold {\r\n    font-weight: 700;\r\n    text-decoration: underline;\r\n}\r\n\r\n@media print {\r\n    body {\r\n        display: table;\r\n        table-layout: fixed;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
